( function( $ ) {

    'use strict';

    
    var logoContainerMinH = 82;
    var logoWrapH = 0;
    var logoH = 0;
    var logoDynamicWrap = 0;
    var adminBarHeight = 0;
    var headerHeight = 0;
    var scrollThreshold = 0;
    var stickyMenuSize = 0;
    var stickyMenu = {
        init : function() {
            this.preparation();
            this.createMobileMenu();
            this._events();
        },
        preparation : function() {

            $("body").addClass("my-header-is-stick");

            $('.logo-wrap img').removeAttr('style');
            $('.logo-wrap').removeAttr('style');

            headerHeight = $('header').innerHeight();
            if($("body").hasClass("my-header-is-stick")){
                $(".my-header-is-stick").css('padding-top',headerHeight + "px");
            }
            logoWrapH = $('header .logo-wrap').innerHeight();
            logoH = $('header .logo-wrap img').innerHeight();
            //document.documentElement.scrollTop = 0;
        },
        scrolling : function() {
            var scrollPosition = $(this).scrollTop();

            $("#scroll-monitorer").text(scrollPosition);
            $("#scroll-monitorer2").text($('html').height() + " - " + $('body').height());

            let logoWrap = $('.logo-wrap');
            let currentH = logoWrap.innerHeight();
            
            
            let x = logoWrapH - (scrollPosition/2); 


            if(x >= logoContainerMinH){            
                logoWrap.css('height',x + "px");
                logoWrap.find("img").css("height",logoH+"px");
                logoDynamicWrap = 0;

            }else{
                logoWrap.css('height',logoContainerMinH+"px"); 

                
                logoDynamicWrap = ((scrollPosition/2) - 95)/12.5;
                let z = logoH - logoDynamicWrap;
                if(z >= 45){
                    logoWrap.find("img").css("height",z+"px");
                }else{
                    logoWrap.find("img").css("height","45px");
                }

            }
        },
        adminBar: function() {

            if($('#wpadminbar').length && window.innerWidth > 600){
                $('#wpadminbar').css('display','block');
                adminBarHeight = $('#wpadminbar').height();
                $('#wpadminbar').css('opacity',1);
                $("header",".my-header-is-stick").css("top",adminBarHeight + "px"); 
            }else{
                adminBarHeight = 0;
                $('#wpadminbar').css('display','none');
                $("header",".my-header-is-stick").css("top","0"); 
            }       
        },
        createMobileMenu: function() {
            if(window.innerWidth <= 777){

                $("#mobile-menu").removeClass("move");
                $("body > header > .menu-wrap").removeClass("show");
                $('body').removeClass('menu-showed');

                if(!$("body > header > .menu-wrap").length){
                    $("header").append('<div class="menu-wrap"></div>');
                }
                $($("header .dp-desktop-menu").detach()).appendTo("body > header > .menu-wrap");
                $("header .menu-wrap .dp-desktop-menu").addClass("mobile-menu").removeClass("dp-desktop-menu");
                $("body > header > .menu-wrap > ul > li.menu-item-has-children > a").each(function(e){                     
                    if(!$(this).find(".collapseMenu").length){
                        $(this).append("<span class='trn collapseMenu'><i class='fa fa-chevron-circle-down'></i></span>");
                    }                    
                });
            }else{
                $("body > header > .menu-wrap > ul > li.menu-item-has-children > a").find(".collapseMenu").remove();
                $($("body > header > .menu-wrap > .mobile-menu").addClass('dp-desktop-menu').removeClass('mobile-menu').detach()).appendTo("body > header");
                $("body > header > .menu-wrap").remove();
            }      
        },
        showMobileNav: function() {
            $(this).find("#mobile-menu").toggleClass("move");
            $('body').toggleClass('menu-showed');
            var currentHeaderH = $("body > header").height();
            var headSize = currentHeaderH + adminBarHeight;

            var x = $(".mobile-menu-wrap").position();
            var headSize2 = x.top + adminBarHeight + 55;


            $("body > header > .menu-wrap").css("height","calc(100vh - "+headSize2+"px)");            
            $("body > header > .menu-wrap").toggleClass('show');

        },
        triggerSubMenu: function(e) {
            e.preventDefault();
            $(this).closest("li").find("ul").slideToggle();
            $(this).parent().toggleClass("active");             
        },
        loaderRemove: function() {
            $('body').removeClass('has-loading');
            setTimeout(function(){
                $("#dp-loader").fadeOut();
            },500);
        },
		_events : function() {
            $(window).on('load', this.adminBar );
            $(window).on('scroll', this.scrolling );
            
            $(window).on('resize', this.preparation );
            $(window).on('resize', this.adminBar );
            $(window).on('resize', this.createMobileMenu );

            $(document).on('click', ".mobile-menu-wrap .wrapper", this.showMobileNav);
            $(document).on('click', ".menu-item-has-children span.collapseMenu", this.triggerSubMenu);

            $(window).on('load', this.loaderRemove );
		}        
    }    
    /**
     * INITIALIZE THE HEADER STICKY
     */
    stickyMenu.init();

} ) ( jQuery );